module.exports = __webpack_public_path__ + "static/media/rejected_message_backdrop.22a78e9a.svg";